/**************************************************
 * Nombre:       Formulario_Cange
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     5 Hr
 **************************************************/
import {Grid, Typography} from "@mui/material";
import {
    AccountCircleOutlined,
    ApartmentOutlined,
    BadgeOutlined,
    FlagOutlined,
    FolderZipOutlined,
    Google,
    PhoneAndroid,
    PublicOutlined,
    SignpostOutlined
} from "@mui/icons-material";
import IngresoSelect from "../../Modulo_formularios/Componentes/IngresoSelect";
import IngresoTexto from "../../Modulo_formularios/Componentes/IngresoTexto";
import {PAISESINDICATIVO} from "../../Modulo_formularios/Recursos/indicativos";
import {theme} from "../../Tema";


const Formulario_Cange = ({...props}) => {

    return (
        <form noValidate style={{width: '100%'}}>
            <Grid
                container
                justifyContent={'flex-start'}
                alignItems={'flex-start'}
                size={{xs: 12, sm: 12, md: 12}}
                spacing={2}
            >

                <Grid container size={12} sx={{justifyContent: 'flex-end'}}>
                    <Typography sx={{fontWeight: 600, color: theme.palette.primary.main}}>Datos de envio</Typography>
                </Grid>

                <Grid container size={12}>
                    <IngresoTexto Icono={AccountCircleOutlined} nombre={'Nombre'} dato={'nombre'} {...props}
                                  requerido={'El nombre es requerido'}
                    />
                </Grid>

                <Grid container size={12}>
                    <IngresoTexto Icono={Google} nombre={'Correo'} dato={'correo'} {...props}
                                  editable={false}
                    />
                </Grid>

                <Grid container size={6}>
                    <IngresoSelect Icono={PublicOutlined} nombre={'Pais'} dato={'pais'} {...props}
                                   opciones={PAISESINDICATIVO.map((it) => it.nameES)} requerido={'El pais es requerido'}
                    />
                </Grid>


                <Grid container size={6}>
                    <IngresoTexto Icono={PhoneAndroid} nombre={'Celular'} dato={'celular'} {...props}
                                  requerido={'El numero celular es requerido'}
                    />
                </Grid>

                <Grid container size={6}>
                    <IngresoTexto Icono={FlagOutlined} nombre={'Provincia / Departamento'}
                                  dato={'departamento'} {...props}
                                  requerido={'El estado/provincia es requerido'}
                    />
                </Grid>

                <Grid container size={6}>
                    <IngresoTexto Icono={ApartmentOutlined} nombre={'Ciudad'} dato={'ciudad'} {...props}
                                  requerido={'La ciudad es requerida'}
                    />
                </Grid>

                <Grid container size={6}>
                    <IngresoTexto Icono={FolderZipOutlined} nombre={'Codigo Postal'} dato={'codigoPostal'} {...props}
                                  requerido={'El codigo postal es requerido'}
                    />
                </Grid>

                <Grid container size={6}>
                    <IngresoTexto Icono={BadgeOutlined} nombre={'Num Identificacion '} dato={'cc'} {...props}
                                  requerido={'El num de identificacion es requerido'}
                    />
                </Grid>

                <Grid container size={12}>
                    <IngresoTexto Icono={SignpostOutlined} nombre={'Direccion'} dato={'direccion'} {...props}
                                  requerido={'La direccion es requerida'}
                    />
                </Grid>

                <Grid container size={12}>
                    <IngresoTexto lineas={4} nombre={'Indicaciones Adicionales'} dato={'inicaciones'}
                                  {...props}
                    />
                </Grid>


            </Grid>

        </form>

    )

}
export default Formulario_Cange